<template>
  <div  id="app page-top"  class="landing-page no-skin-config">
    <router-view/>
  </div>
</template>


<script>
export default {
  name: 'App'
}
</script>

<style>
/* 富文本编辑的字体文件 */
@import "../static/css/font.css";
#app {

}
</style>



// WEBPACK FOOTER //
// src/App.vue